var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sample-header'),_c('coupon-status',{attrs:{"code":_vm.code}}),_c('sample-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }